module.exports = __webpack_public_path__ + "8f3e6a0c246fa0c818d010c70f358701.pdf";